
// OFFICE > PAYRATES > GETTERS

export default {
  allPayRates (state) {
    return state.payrates
  }
}